import { useEffect, useState } from "react";

/**
 * Debounce a rapidly-changing value (e.g. a search input) so downstream
 * queries do not fire once per keystroke — the historical "one-character
 * input" defect where each typed character triggered a full server round-trip.
 *
 * The debounced value only updates after the input has been stable for
 * `delay` milliseconds, collapsing a burst of edits into a single change.
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}